import {useContext} from "react";
import {ProjectContext} from "../ProjectProvider";
import {
    Button,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    List, ListItem,
    ListItemText
} from "@mui/material";
import {Dialog2} from "../../../misc/Dialog2";
import {useAsync2} from "nate-react-api-helpers";
import {api} from "../../../api/API";

export function AlertProjectDiscontinuedProducts(props: {}) {
    const proj = useContext(ProjectContext);

    if(!proj.value) return null;
    if(!proj.value.notifyDiscontinuedProducts) return null;

    return (
        <Dialog2 open>
            <DialogTitle>
                Project uses Discontinued Products
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Please review the following products and make any replacements necessary. You can also see further details via the Hardware screen.
                </DialogContentText>

                <DiscontinuedProductsForProject project={proj.value.id} />
            </DialogContent>
            <DialogActions>
                <Button onClick={() => {
                    proj.update(Object.assign({}, proj.value, {
                        notifyDiscontinuedProducts: false,
                    }));
                }}>Dismiss</Button>
            </DialogActions>
        </Dialog2>
    )
}

function DiscontinuedProductsForProject(props: {
    project: number;
}) {
    const list = useAsync2(input => api.products.discontinuedForProject(input), {project: props.project}, [props.project]);

    return (
        <List>
            {list.LoadingOrErrorElement}
            {list.asList.map(p => (
                <ListItem>
                    <ListItemText
                        primary={p.categoryName + " - " + p.productCode}
                        secondary={p.manufacturerName}
                    />
                </ListItem>
            ))}
        </List>
    )
}